module.exports = __webpack_public_path__ + "img/txt.8384efeb.png";